// Author YuJiaBei
// Date 2021-09-26 21:36:40

class EmSicUploadFileSuf {
constructor({
        id = null,
        sufName = '',
        sufPath = '',
        sufContent = '',
        sufStatus = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sufName = sufName;
    this.sufPath = sufPath;
    this.sufContent = sufContent;
    this.sufStatus = sufStatus;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicUploadFileSuf();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sufName',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.sufName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sufPath',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.sufPath',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sufContent',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.sufContent',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sufStatus',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.sufStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicUploadFileSuf.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    sufNameFilter : "",
    sufPathFilter : "",
    sufContentFilter : "",
    sufStatusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sufNameFilter',
        label: 'label.em.statusCollection.emSicUploadFileSuf.filter.sufName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufPathFilter',
        label: 'label.em.statusCollection.emSicUploadFileSuf.filter.sufPath',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufContentFilter',
        label: 'label.em.statusCollection.emSicUploadFileSuf.filter.sufContent',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufStatusFilter',
        label: 'label.em.statusCollection.emSicUploadFileSuf.filter.sufStatus',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sufName',
        label: 'label.em.statusCollection.emSicUploadFileSuf.entity.sufName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufPath',
        label: 'label.em.statusCollection.emSicUploadFileSuf.entity.sufPath',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufContent',
        label: 'label.em.statusCollection.emSicUploadFileSuf.entity.sufContent',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sufStatus',
        label: 'label.em.statusCollection.emSicUploadFileSuf.entity.sufStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicUploadFileSuf.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicUploadFileSuf, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
